import { eligibilitySteps } from '../constants/eligibility';
import { sessionAtom } from '../lib/recoil/persist';

const eligibilityActiveStep = sessionAtom<number>({
  key: 'eligibilityProgress/activeStep',
  default: eligibilitySteps.yourProgram.key,
});

export { eligibilityActiveStep };
